import * as Sentry from "@sentry/browser";
import { CaptureConsole } from "@sentry/integrations";

export const InitializeCrashReporter = () => {

    const initErrors = [];

    let environment;

    try {
        const href = window.location.href;

        if (/^https:\/\/lendingdigital\.meridiancu\.ca\/mortgages\/$/.test(href)) {
            environment = "production";
        } else if (/^https:\/\/intlendingdigital\.meridiancu\.ca\/mortgages\/$/.test(href)) {
            environment = "integration";
        } else if (/^https?:\/\/localhost/.test(href)) {
            environment = "development";
        }
        else {
            environment = "QA";
        }

        environment = environment || "Unknown";
    } catch (e) {
        initErrors.push(e);
    }

    Sentry.init({
        dsn: "https://e0070e46e13bbdd8e96dac781040b871@o352771.ingest.us.sentry.io/4507249627430912",
        environment,
        attachStacktrace: true,
        autoSessionTracking: true,
        integrations: [
            new CaptureConsole({
                levels: ["warn", "error"], // explicitly not including "log" since that should only be used for debugging.
            }),
        ],
        tracesSampleRate: environment == "development" ? 1.0 : environment == "QA" ? 0.2 : 0.2,
        denyUrls: [
            /www\.google-analytics\.com/i,
            /stats\.g\.doubleclick\.net/i
        ]
    });

    if (initErrors.length) {
        initErrors.forEach((v) => {
            Sentry.captureException(v);
        });
    }
};